import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  pauseStatusData: {},
};
const studentPauseResumeSlice = createSlice({
  name: "studentPauseResume",
  initialState,
  reducers: {
    setPauseStatusData: (state, action) => {
      state.pauseStatusData = { ...action.payload };
    },
  },
});

export const { setPauseStatusData } = studentPauseResumeSlice.actions;
export default studentPauseResumeSlice.reducer;
